import { Component, ElementRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { hasFormFieldHorizontalWrapper } from '../../formly-label.util';

@Component({
  standalone: false,
  selector: 'app-formly-field-checkbox',
  templateUrl: './formly-field-checkbox.component.html',
  styleUrls: ['./formly-field-checkbox.component.scss']
})
export class FormlyFieldCheckboxComponent extends FieldType
{
  constructor(private readonly elementRef: ElementRef<HTMLElement>)
  {
    super();
  }

  /** Horizontal: label in wrapper column; vertical: label on k-checkbox. */
  public get isHorizontalLayout(): boolean
  {
    return hasFormFieldHorizontalWrapper(this.field)
      || !!this.elementRef.nativeElement.closest('app-formly-wrapper-horizontal');
  }
}
